import React from "react";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";

// @mui material components
import Grid from "@mui/material/Grid";

const Landing = (props) => {
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={3}>
                <Grid container justifyContent="flex-start" alignItems="flex-start">
                    <Grid item xs={12} md={7} lg={5} mr="auto" position="relative">
                        Home page for all template plugin.
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
}

export default Landing;